export enum MatchType {
  ALL = "ALL",
  ANY = "ANY",
  EXACT = "EXACT"
}
